import styled from "styled-components";
import React, { memo, useContext } from "react";
import { textColor, dividerColor } from "../../../helpers/color";
import { useAmp } from "./state/amp";
import ClipContext from "./ClipContext";
export const WaveRoot = /*#__PURE__*/styled.div.withConfig({
  displayName: "WaveRoot",
  componentId: "sc-1njz93c-0"
})(["position:absolute;top:0;bottom:0;display:flex;flex-direction:column;color:", ";pointer-events:none;backface-visibility:hidden;"], textColor);
const Child = /*#__PURE__*/styled.div.withConfig({
  displayName: "Child",
  componentId: "sc-1njz93c-1"
})(["overflow:hidden;position:relative;flex:1;& + &{border-top:1px solid ", ";}*{display:block;width:100%;height:100%;}"], dividerColor);
const Zoom = /*#__PURE__*/styled.div.withConfig({
  displayName: "Zoom",
  componentId: "sc-1njz93c-2"
})(["position:absolute;top:50%;left:0;width:100%;height:100%;transform:translateY(-50%);"]);
const Wave = /*#__PURE__*/memo(({
  amp,
  end,
  start,
  children
}) => {
  amp = amp * useAmp();
  const clip = useContext(ClipContext);
  const waveLength = end - start;
  const clipLength = clip.end - clip.start;
  const scale = waveLength / clipLength;
  const left = (clip.start - start) / waveLength * 100;
  const width = scale * 100;
  const height = amp * 100;
  return /*#__PURE__*/React.createElement(WaveRoot, {
    style: {
      width: `${width}%`,
      transform: `translate3d(${-left}%,0,0)`
    }
  }, React.Children.map(children, child => /*#__PURE__*/React.createElement(Child, null, /*#__PURE__*/React.createElement(Zoom, {
    style: {
      height: `${height}%`
    }
  }, child))));
});
Wave.defaultProps = {
  amp: 1,
  end: 0,
  html: "",
  start: 0
};
export default Wave;
//# sourceMappingURL=Wave.js.map